module.exports = __webpack_public_path__ + "assets/youtube4.8044c23a.svg";